import React from 'react';

const Item = ({ name, location, startDate, endDate, color, expectedCategory, category, description, selectItem }) => (expectedCategory === 'All Categories' || category === expectedCategory) ? (
  <button className="sc__list__item" onClick={() => selectItem({
    name, location, startDate, endDate, color, description
  })}>
    <div className="sc__list__item__dot" style={{background: color}}></div>
    <h4>{name}</h4>
    <p className="sc__list__item__time">{startDate} - {endDate}</p>
    <p className="sc__list__item__location">{location}</p>
  </button>
) : null;
export default Item;


// WEBPACK FOOTER //
// ./src/components/Schedule/ScheduleComponent/Item.jsx